import { useAppointmentFeesQuery } from "../../../../../../../api/appointments/useAppointmentFeesQuery";
import { uiNotification } from "../../../../../../../services/UINotificationService";
import { useContext } from "../context";

export function useAppointmentFees() {
  const { appointment } = useContext();

  const { data, isLoading } = useAppointmentFeesQuery(
    { appointmentId: appointment.id },
    {
      staleTime: 0,
      onError: () => {
        uiNotification.error(
          "Failed to fetch appointment fees. Please try again later.",
        );
      },
    },
  );

  return {
    cancelationFee: data?.cancelationFee || 0,
    isLoading,
  };
}
